import { render } from "./ChangeMotPass.vue?vue&type=template&id=3a726aee&scoped=true"
import script from "./ChangeMotPass.vue?vue&type=script&lang=js"
export * from "./ChangeMotPass.vue?vue&type=script&lang=js"

import "./ChangeMotPass.vue?vue&type=style&index=0&id=3a726aee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a726aee"]])

export default __exports__